module.exports = __webpack_public_path__ + "img/combo.715fb3f8.png";